var Model = require("../types/Model");

module.exports = Model({
	name: "ownresourceslist",
	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners,

	_loadded: null,

	refresh: refresh,
	pushResources: pushResources
});

function init(){
	this._resources = null;
	this._loadded = false;
}

function uninit(){
	this._resources = null;
	this._loadded = false;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"mqtt:$/resource/set": refresh,
		"mqtt:$/resource/added": refresh,
		"mqtt:$/resource/removed": refresh
	};
}

function triggers(){
	return {
		"list": list
	};
}

function list() {
	this._loadded = true;
	this.refresh();
}

function refresh() {
	if(this._loadded) {
		this.emit("save:trigger:start");
		this.api.resources.list()
			.then(setResources.bind(this))
			.catch(handleError.bind(this));
	} else return;
}

function setResources(data){
	this.pushResources(data);
	this.emit("save:trigger:finish");
}

function pushResources(data){
	this._resources = data;
	this.push(data);
}

function handleError(error){
	console.log(error);
	this.emit("save:trigger:finish");
}
